GP.models.Activity = Backbone.Model.extend({
    idAttribute:'id',
    defaults:{
        id: null,
        type: null,
        duid: null,
        content_id: null,
        text: null
    }
});
